module.exports = __webpack_public_path__ + "static/argo_banner-e8a846910cafd3094a2971ca4325ebfe.png";